import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorsSidenavComponent } from './errors-sidenav.component';
import { EffectsModule } from '@ngrx/effects';
import { ErrorEffects } from './store/effects';
import { StoreModule } from '@ngrx/store';
import * as fromErrors from './store';
import { MessageModule } from '../efaact-primeng.module';
import { PopoverModule } from 'primeng/popover';

@NgModule({
    imports: [
        MessageModule,
        CommonModule,
        PopoverModule,
        StoreModule.forFeature('errors', fromErrors.reducer),
        EffectsModule.forFeature([ErrorEffects])
    ],
    declarations: [ErrorsSidenavComponent],
    exports: [ErrorsSidenavComponent]
})
export class ErrorsSidenavModule {}
